import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Image from '@kurtosys/ksys-app-components/dist/components/base/Image';

export default InjectedStyledComponent(Image, 'assurance', ['imageComponent']);